import { GrantsType, hasScopedPermission } from '../../Shared/utils/auth';

export const editVehicleInspectionPolicy = (grants: GrantsType) =>
  hasScopedPermission(grants, 'partner', 'vehicle_inspections.edit');
